import { IPairing, IRegLimitEvaluation } from "@vmosolutions/oc-interfaces";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import AmplifyAPIWrapper, { INotifications } from "src/API/AmplifyAPIWrapper";

/**
 * Fetches the regulation-limit (FDP) evaluation for a pairing from the backend. The full pairing is sent
 * as the request body so the backend evaluates the current (possibly unsaved/draft) editor state.
 *
 * The result is held in local component state by the caller (not redux) and re-fetched on demand.
 * Returns null if the request fails or returns no body.
 *
 * When a `dispatch` is supplied, info/success/error notifications are shown for the fetch.
 */
export const fetchRegLimitEvaluation = async (
  pairing: IPairing,
  draft: boolean = false,
  dispatch?: ThunkDispatch<object, object, AnyAction>
): Promise<IRegLimitEvaluation | null> => {
  const notifications: INotifications | undefined = dispatch
    ? {
        dispatch: dispatch,
        infoMessage: "Fetching FDP Limits",
        successMessage: "FDP Limits Successfully Fetched",
        errorMessage: "Error: Unable To Fetch FDP Limits",
      }
    : undefined;
  const response = await AmplifyAPIWrapper.Post<IRegLimitEvaluation>(
    "/violations/evaluate",
    {
      pairing: pairing,
      draft: draft,
    },
    notifications
  );
  return response;
};
